import { sharedFriendsService } from "Roblox";
import angular from "angular";
import chatModule from '../chatModule';

function friendsController($scope, chatUtility, friendsInfoService, usersService) {
    "ngInject";

    $scope.dialogLayout.scrollToBottom = false;
    $scope.dialogLayout.IsdialogContainerVisible = false;
    $scope.dialogParams = Object.assign({}, chatUtility.dialogParams);
    $scope.dialogType = Object.assign({}, chatUtility.dialogType);
    $scope.userPresenceTypes = Object.assign({}, chatUtility.userPresenceTypes);
    $scope.friendsScrollbarElm = chatUtility.getScrollBarSelector($scope.dialogData, chatUtility.scrollBarType.FRIENDSELECTION);
    $scope.dialogData.scrollBarType = chatUtility.scrollBarType.FRIENDSELECTION;

    $scope.dialogData.isCreated = true;

    $scope.updateFriendsDictData = function (friends) {
        var userIds = [];
        angular.forEach(friends, function (friend, userId) {
            friend.id = parseInt(userId);
            if (!$scope.chatLibrary.friendsDict[userId]) {
                $scope.chatLibrary.friendsDict[userId] = friend;
                userIds.push(userId);
            }

        });
        $scope.updateFriends(friends);
        if (userIds && userIds.length > 0) {
            usersService.getAvatarHeadshots(userIds, $scope.chatLibrary.friendsDict);
        }
    }

    var getFriends = function () {
        var cacheCriteria = {
            isEnabled: $scope.chatLibrary.isUsingCacheToLoadFriendsInfoEnabled,
            expirationMS: $scope.chatLibrary.cachedDataFromLocalStorageExpirationMS
        }
        sharedFriendsService.register($scope.updateFriendsDictData, cacheCriteria);
    }

    if ($scope.chatLibrary.friendIds.length > 0) {
        $scope.updateFriends();
    }
    getFriends();
    $scope.isOverLoaded();
};

chatModule.controller("friendsController", friendsController);

export default friendsController;